// https://www.algolia.com/old-docs/integration/shopify/building-search-ui/frontend-custom-events/?client=ruby
// https://support.algolia.com/hc/en-us/articles/14424771026833--Shopify-Can-I-have-a-second-Searchbox-for-mobile-on-the-same-page
// MAIN LAYOUT
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="container-fluid py-4 py-lg-5">
        <div class="row">
            <div class="col-lg-2">
                ${displaySuggestions &&
                html`
                    <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle"
                        >${algoliaShopify.translations.suggestions}</span
                    >
                    <div class="aa-SourceHeaderLine" />
                    </div>
                    ${elements.querySuggestionsPlugin}
                `}
                ${elements.collections} ${elements.articles} ${elements.pages}
                ${elements.redirectUrlPlugin}
            </div>
            <div class="col-lg-10 mt-4 mt-lg-0 aa-product-list">
              ${elements.products}
            </div>
        </div>
      </div>
    `;
  });
});

// headings
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    const searchBanner = window.themeSettings?.search_banner;
    console.log('search:', searchBanner);
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${algoliaShopify.translation_helpers.render_title(
            resource,
            state.query
          )}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
      ${resource === 'Products' && searchBanner ? html`<div class="text-center"><img src="${searchBanner}" class="img-fluid" alt="Search Banner" /></div>` : ''}
    `;
  });
});


// PRODUCTS
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;

      // Format prices
      let hasSalePrice = 0;
      let salePercentage = 0;
      let salePrice = 0;
      let regularPrice = 0; 

      if (item.variants_count > 1) {
        const minPrice = item.variants_min_price;
        const maxPrice = item.variants_max_price;
        const minCompareAt = item.variants_compare_at_price_min;
        const maxCompareAt = item.variants_compare_at_price_max; 
         
        const minStriked = minCompareAt > 0 ? algoliaShopify.helpers.displayStrikedPrice(minPrice, minCompareAt) : algoliaShopify.helpers.displayStrikedPrice(minCompareAt, minPrice);
        const maxStriked = maxCompareAt > 0 ? algoliaShopify.helpers.displayStrikedPrice(maxPrice, maxCompareAt) : algoliaShopify.helpers.displayStrikedPrice(maxCompareAt, maxPrice);

        // Get sale price and regular price
        hasSalePrice = (minCompareAt > 0 && minCompareAt > minPrice) || (maxCompareAt > 0 && maxCompareAt > maxPrice);
        
        // Calculate sale percentage
        salePercentage = hasSalePrice 
          ? Math.round(((minCompareAt > 0 ? minCompareAt : maxCompareAt) - (minCompareAt > 0 ? minPrice : maxPrice)) / (minCompareAt > 0 ? minCompareAt : maxCompareAt) * 100)
          : 0;
    
        regularPrice = `${minStriked} - ${maxStriked}`;
      } else { 
        // Get sale price and regular price
        hasSalePrice = item.compare_at_price > 0 && item.compare_at_price > item.price;
        
        // Calculate sale percentage
        salePercentage = hasSalePrice 
          ? Math.round(((item.compare_at_price - item.price) / item.compare_at_price) * 100)
          : 0;

        // Create compare at item
        const compareAtItem = { ...item, price: item.compare_at_price };
        
        regularPrice = hasSalePrice ? algoliaShopify.helpers.displayPrice(compareAtItem, distinct) : null;
      }

      salePrice = algoliaShopify.helpers.displayPrice(item, distinct);

      return html`
        <a
          href="${itemLink}"
          class="aa-product-item d-flex justify-content-between flex-column h-100 position-relative"
          onClick="${() => trackSearchAttribution(item)}"
        >
          ${hasSalePrice ? html`
            <div class="aa-product-badge position-absolute end-0 bg-danger text-white bg-primary p-1 fs-xs fw-bold z-3" style="top:3%;border-radius:4px 0 0 4px;">
              ${salePercentage}%
            </div>
          ` : ''}
            <div>
                <div class="aa-product-image-wrapper position-relative overflow-hidden">
                    <img
                        src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                        srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                        sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                        alt="${item.title}"
                        class="position-absolute top-0 start-0 end-0 mx-auto object-fit-contain"
                    />
                </div>
                <div class="aa-product-title">${components.Highlight({ hit: item, attribute: "title" })}</div>
            </div>
            <div class="aa-product-pricing d-flex gap-2 align-items-center">
              ${hasSalePrice ? html`
                
                <div class="aa-product-regular-price text-muted text-decoration-line-through">${regularPrice}</div>
                <div class="aa-product-sale-price text-danger fw-bold">${salePrice}</div>
              ` : html`
                <div class="aa-product-price">${salePrice}</div>
              `}
            </div>
        </a>
      `;
      }
  );
});

// no results
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="container-fluid py-4 py-lg-5 text-center">
        <p class="aa-NoResultsHeader">
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
        </p>
        <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=${state.query}">
          ${algoliaShopify.translations.allProducts}
        </a>
      </div>
    `;
  });
});